export default __webpack_public_path__ + "103ffe1fe0b099adaa7c4aeec543c168.jpg";